'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startsWith = require('core-js/library/fn/string/starts-with');

var everythingAtTheEnd = /[^.]+$/;
var everythingAfterCount = /count\.([^\/]+)$/;
var latencyMetricNameAndBucket = /latency\.([^\/]+)\.bucket\.([0-9]+)$/;

var KeyBuilder = function () {
  function KeyBuilder(settings) {
    (0, _classCallCheck3.default)(this, KeyBuilder);

    this.settings = settings;
  }

  (0, _createClass3.default)(KeyBuilder, [{
    key: 'buildSplitKey',
    value: function buildSplitKey(splitName) {
      return this.settings.storage.prefix + '.split.' + splitName;
    }
  }, {
    key: 'buildSplitsTillKey',
    value: function buildSplitsTillKey() {
      return this.settings.storage.prefix + '.splits.till';
    }
  }, {
    key: 'buildSplitsReady',
    value: function buildSplitsReady() {
      return this.settings.storage.prefix + '.splits.ready';
    }
  }, {
    key: 'isSplitKey',
    value: function isSplitKey(key) {
      return startsWith(key, this.settings.storage.prefix + '.split.');
    }
  }, {
    key: 'buildSegmentNameKey',
    value: function buildSegmentNameKey(segmentName) {
      return this.settings.storage.prefix + '.segment.' + segmentName;
    }
  }, {
    key: 'buildSegmentTillKey',
    value: function buildSegmentTillKey(segmentName) {
      return this.settings.storage.prefix + '.segment.' + segmentName + '.till';
    }
  }, {
    key: 'buildRegisteredSegmentsKey',
    value: function buildRegisteredSegmentsKey() {
      return this.settings.storage.prefix + '.segments.registered';
    }
  }, {
    key: 'buildSegmentsReady',
    value: function buildSegmentsReady() {
      return this.settings.storage.prefix + '.segments.ready';
    }
  }, {
    key: 'buildVersionablePrefix',
    value: function buildVersionablePrefix() {
      return this.settings.storage.prefix + '/' + this.settings.version + '/' + this.settings.runtime.ip;
    }
  }, {
    key: 'buildImpressionsKeyPrefix',
    value: function buildImpressionsKeyPrefix() {
      return this.buildVersionablePrefix() + '/impressions';
    }
  }, {
    key: 'buildImpressionsKey',
    value: function buildImpressionsKey(splitName) {
      return this.buildImpressionsKeyPrefix() + '.' + splitName;
    }
  }, {
    key: 'buildLatencyKeyPrefix',
    value: function buildLatencyKeyPrefix() {
      return this.buildVersionablePrefix() + '/latency';
    }
  }, {
    key: 'buildLatencyKey',
    value: function buildLatencyKey(metricName, bucketNumber) {
      return this.buildLatencyKeyPrefix() + '.' + metricName + '.bucket.' + bucketNumber;
    }
  }, {
    key: 'buildCountKey',
    value: function buildCountKey(metricName) {
      return this.buildVersionablePrefix() + '/count.' + metricName;
    }
  }, {
    key: 'buildGaugeKey',
    value: function buildGaugeKey(metricName) {
      return this.buildVersionablePrefix() + '/gauge.' + metricName;
    }
  }, {
    key: 'searchPatternForCountKeys',
    value: function searchPatternForCountKeys() {
      return this.buildVersionablePrefix() + '/count.*';
    }
  }, {
    key: 'searchPatternForSplitKeys',
    value: function searchPatternForSplitKeys() {
      return this.settings.storage.prefix + '.split.*';
    }
  }, {
    key: 'searchPatternForImpressions',
    value: function searchPatternForImpressions() {
      return this.buildImpressionsKeyPrefix() + '.*';
    }
  }, {
    key: 'searchPatternForLatency',
    value: function searchPatternForLatency() {
      return this.buildLatencyKeyPrefix() + '.*';
    }
  }, {
    key: 'extractKey',
    value: function extractKey(builtKey) {
      var s = builtKey.match(everythingAtTheEnd);

      if (s && s.length) {
        return s[0];
      } else {
        throw 'Invalid latency key provided';
      }
    }
  }, {
    key: 'extractCounterName',
    value: function extractCounterName(counterKey) {
      var m = counterKey.match(everythingAfterCount);

      if (m && m.length) {
        return m[1]; // everything after count
      } else {
        throw 'Invalid counter key provided';
      }
    }
  }, {
    key: 'extractLatencyMetricNameAndBucket',
    value: function extractLatencyMetricNameAndBucket(latencyKey) {
      var parts = latencyKey.match(latencyMetricNameAndBucket);

      if (parts && parts.length > 2) {
        return {
          metricName: parts[1],
          bucketNumber: parts[2]
        };
      } else {
        throw 'Invalid counter key provided';
      }
    }
  }]);
  return KeyBuilder;
}();

module.exports = KeyBuilder;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/Keys.js
// module id = 396
// module chunks = 10